import { useEffect, useState, forwardRef } from "react";
import { useSelector } from 'react-redux';
import MultiSelectDropDown from "../form-components/MultiSelectDropDownComponent";
import MultiSelectDropDownForm from "../form-components/MultiSelectDropDownFormComponent";
import { PostRequestCached } from "../generics/helper";

const StoreAutocomplete = forwardRef((props, ref) => {
    const { allOption = false, selectedValues = [], editMode = false, forStoreType = null, forBranchId = null, isFormikFormField = false, showFormError = false,
        isCompulsory = false, singleSelect = true, label = "Store", searchPlaceholder = "Search By Store Name",
        noDataLabel = "No Store Found", width = '100%', listWidth = width, userStoreId = null, storeFilt = false,
        ...rest } = props;
    let storeOptions = [];
    if (allOption) {
        storeOptions.unshift({ storeDisplayName: 'All Stores', storeId: '' })
    }
    let initialProps = {
        ...rest,
        labelKey: 'storeDisplayName',
        primaryKey: 'storeId',
        options: storeOptions,
        isObject: true,
        isFormikFormField,
        showFormError,
        isCompulsory,
        singleSelect,
        label,
        searchPlaceholder,
        noDataLabel,
        width,
        listWidth,
        dataLoaded: false,
        editMode
    }
    const [defaultProps, setDefaultProps] = useState(initialProps);
    // Get Options
    const userToken = useSelector((state) => state.login.userToken);

    const getStoreOptions = async () => {
        let getStoreParams = {};
        if (forStoreType && forStoreType > 0) {
            getStoreParams = { ...getStoreParams, storeType: forStoreType };
        }                
        if (forBranchId && forBranchId !== '') {            
            getStoreParams = { ...getStoreParams, branchId: forBranchId };
        }
        // const response = await fetchApi('masters/getStores',getStoreParams,userToken);
        const response = await PostRequestCached('masters/getStores', getStoreParams, userToken);
        if (response.status === 'Ok' && response.data.responseStatus === 'Ok') {
            let newOptions = [];
            if (allOption) {
                newOptions.unshift({ storeDisplayName: 'All Stores', storeId: '' })
            }
            if (response.data.stores.length > 0) {
                if (storeFilt === true) {
                    let filteredStores = response.data.stores.filter((item) => item.storeId !== userStoreId);
                    newOptions = newOptions.concat(filteredStores);
                } else {
                    newOptions = newOptions.concat(response.data.stores);
                }
            }
            let preSelectedValues = [];
            if (selectedValues.length > 0) {
                preSelectedValues = newOptions.filter((s) => selectedValues.indexOf(s.storeId) >= 0);
            }
            const newProps = { ...defaultProps, options: newOptions, preSelectedValues, dataLoaded: true }
            setDefaultProps(newProps);
        }
    }

    useEffect(() => {
        getStoreOptions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (forStoreType)
            getStoreOptions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [forStoreType]);

    useEffect(() => {
        let preSelectedValues = [];
        if (selectedValues.length > 0) {
            preSelectedValues = defaultProps.options.filter((s) => selectedValues.indexOf(s.storeId) >= 0);
        }
        setDefaultProps({ ...defaultProps, editMode, preSelectedValues });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editMode]);

    return (defaultProps.dataLoaded || editMode ?
        !isFormikFormField ?
            <MultiSelectDropDown
                ref={ref}
                {...defaultProps}
            /> :
            <MultiSelectDropDownForm
                ref={ref}
                {...defaultProps}
            /> : <></>
    );
});

export default StoreAutocomplete;